import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M338.81755,398.616654 L745.624489,733.82015 L338.81755,1069.02365 L338.81755,846.759334 L225.878367,846.759334 L225.878367,1750.2728 L0,1750.2728 L0,620.880967 L338.81755,620.880967 L338.81755,398.616654 Z M1920,1524.38314 L1920,1750.26151 L677.668982,1750.26151 L677.668982,1524.38314 L1920,1524.38314 Z M1920,1072.51347 L1920,1298.50477 L677.668982,1298.50477 L677.668982,1072.51347 L1920,1072.51347 Z M1242.3649,620.869673 L1242.3649,846.74804 L1016.48653,846.74804 L1016.48653,620.869673 L1242.3649,620.869673 Z M1581.18245,620.869673 L1581.18245,846.74804 L1355.30408,846.74804 L1355.30408,620.869673 L1581.18245,620.869673 Z M1920,620.869673 L1920,846.74804 L1694.12163,846.74804 L1694.12163,620.869673 L1920,620.869673 Z M1920,169 L1920,394.991306 L677.668982,394.991306 L677.668982,169 L1920,169 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMoveUpSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconMoveUpSolid, _Component);

  var _super = _createSuper(IconMoveUpSolid);

  function IconMoveUpSolid() {
    _classCallCheck(this, IconMoveUpSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconMoveUpSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMoveUp",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMoveUpSolid.displayName = "IconMoveUpSolid";
  return IconMoveUpSolid;
}(Component);

IconMoveUpSolid.glyphName = 'move-up';
IconMoveUpSolid.variant = 'Solid';
IconMoveUpSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMoveUpSolid;
export { IconMoveUpSolid };